import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../Routes/AuthProvider";

const PrivateRoute = ({ children }) => {
  const { token } = useContext(AuthContext); // read token from context

  return token ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;